import { deserializeSnakeCase, serializeSnakeCase } from '@/utils/snake-case-converter'
import apiClient from '../clearwatt-api-client'
import { NewsletterRequest } from './user.types'

export const signupNewsletter = async (request: NewsletterRequest): Promise<void> => {
  const serializedRequest = serializeSnakeCase<NewsletterRequest>(request)
  const result = await apiClient(`/users/post_newsletter_subscription/`, {
    method: 'POST',
    data: serializedRequest,
  })
  return
}
